import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export interface TrackLearnStripCardClickProps extends DeferredNavigationProps {
  data: {
    interactionLocation: string;
    linkUrl: string;
    linkText: string;
    carouselSlideName: string;
    index: number;
  };
}

export const trackLearnStripCardClick = ({
  data,
  ...deferral
}: TrackLearnStripCardClickProps) => {
  const { interactionLocation, linkUrl, linkText, carouselSlideName, index } =
    data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_advice_card',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        carousel_slide_name: carouselSlideName,
        index,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
